import Link from "next/link";
import { useRouter } from "next/router";

import { twMerge } from "tailwind-merge";

import CustomCard from "components/CustomCard";
import DiscussionSnippet from "components/DiscussionSnippet";
import { useApi } from "hooks/useApi";
import { baseFetcher } from "utils/baseFetcher";

import { collectionDiscussionsUrl } from "../CollectionPageDiscussions/CollectionPageDiscussionsList";

type CollectionPageDiscussionsWidgetProps = {
  card?: boolean;
  widget?: boolean;
};

const CollectionPageDiscussionsWidget = ({
  widget,
}: CollectionPageDiscussionsWidgetProps) => {
  const router = useRouter();
  const slug = router.query.slug as string;

  const { data } = useApi(collectionDiscussionsUrl(slug, 1), baseFetcher);

  if (!data?.data?.length) return <></>;

  const content = (
    <>
      <div>
        <div
          className={twMerge(
            "px-[15px]",
            "py-[10px]",
            "font-medium",
            "text-[16px]",
            "text-[#1f1f20]"
          )}
        >
          Discussions
        </div>
        <div className="overflow-y-auto h-[380px] px-[15px]">
          {data?.data
            ?.filter?.(
              (discussion: any) =>
                !discussion?.isDeleted && !discussion?.hasBeenDeleted
            )
            ?.map?.((discussion: any) => (
              <DiscussionSnippet
                key={discussion.id}
                discussion={discussion}
                className={twMerge(
                  "mb-[10px] last-of-type:mb-0",
                  "p-[10px]",
                  "border border-solid border-[#dae1e7] rounded-[5px]"
                )}
                noBorder
                style="compact"
              />
            ))}
        </div>
        <div className="p-[15px]">
          <Link
            href={`/collections/${slug}/discussions`}
            className={twMerge("text-[14px]", "font-medium", "text-smart-teal")}
          >
            View More »
          </Link>
        </div>
      </div>
    </>
  );

  if (widget) {
    return <CustomCard className="p-0">{content}</CustomCard>;
  }

  return content;
};

export default CollectionPageDiscussionsWidget;
